import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Modal } from 'react-bootstrap-v5'
import axios from 'axios'
//const type = parse(history.location.search).type as string;

import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { setCompanyVerificationMethod, setEntityData, setLoanStep } from './redux/actions'
import { AlexiApplicationTypes } from '../../../utils/constants/AlexiApplicationType.enum'
import { setEntityDataPartner } from '../partnerConnect/redux/actions'
import { AlexiRoutes } from '../../../utils/constants/AlexiRoutes.enum'
import { CompanyProfile } from '../../../svg/CompanyProfileIcon'
import { BankIcon } from '../../../svg/BankIIcon'
import { TileIcon } from '../../../svg/TileIcon'

interface Props {
  show: boolean
  handleClose: any
  // goToStep:any;
}

const CompanyVerification: FC<Props> = ({
  show,
  handleClose,
}: // goToStep
any) => {
  const dispatch = useDispatch()
  const history: any = useHistory()
  const loanApplicationId = localStorage.getItem('loanApplicationId')
  const loanType = localStorage.getItem('loanType')
  const partnerId = localStorage.getItem('partnerId')

  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const companyVerificationMethod = useSelector(
    (state: any) => state.loan.companyVerificationMethod
  )

  const selectCompanyVerificationMethod = (method: number) => {
    dispatch(setCompanyVerificationMethod(method))
  }

  const connectMyInfo = async () => {
    localStorage.setItem('loanApplicationId', loanApplication?.id)
    localStorage.setItem('singpass', 'myinfobiz')

    // const singPassUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : 'https://iris-dev.credilinq.ai/api/alexi-singpass';
    const singPassUrl = process.env.REACT_APP_SINGPASS_URL || 'http://localhost:3002'

    const getEnv = await axios.get(singPassUrl + '/getEnvSMECCR').then((response) => response.data)

    const state = Math.floor(Math.random() * 100000)
    const {
      clientId,
      redirectUrl,
      attributes,
      purpose,
      environment,
      authApiUrl,
      myInfoAuthApiUrl,
      myInfoBizAuthApiUrl,
    } = getEnv
    const authoriseUrl: any = `${authApiUrl}?client_id=${clientId}&attributes=${attributes}&purpose=${purpose}&state=${encodeURIComponent(
      state
    )}&redirect_uri=${redirectUrl}`
    ;(window as any).location = authoriseUrl
  }

  const submitProfileVerification = () => {
    if (companyVerificationMethod === 1) {
      localStorage.setItem('companyVerificationMethod', companyVerificationMethod.toString())
      connectMyInfo()
    } else {
      // goToStep(3);
      dispatch(setLoanStep(3))
      localStorage.setItem('companyVerificationMethod', companyVerificationMethod.toString())

      if (
        loanApplicationId &&
        ['stage', 'sandbox', 'dev'].includes(localStorage.getItem('env') as string)
      ) {
        ;(async () => {
          const response = await import(
            `../../../utils/custom/${loanApplication.companyUEN}/step3.json`
          )
          const eligibilityData: any = response.default
          if (eligibilityData) {
            // Dispatch the action to update the loan eligibility in the Redux store
            dispatch(setEntityData(eligibilityData))
          }
        })()
        history.replace(`/application/${loanApplication.id}?step=3`)
      } else {
        history.replace(`/application/${loanApplication.id}?step=3`)
      }
    }
    handleClose()
  }

  return (
    <>
      <Modal
        className='bg-transparent'
        id='kt_mega_menu_modal'
        data-backdrop='static'
        aria-hidden='true'
        role='dialog'
        tabIndex='-1'
        contentClassName='shadow-none'
        show={show}
        onHide={handleClose}
        centered // Bootstrap's built-in class for centering modals
      >
        <div className='modal-content w-100 px-8'>
          <div className='d-flex flex-column align-items-center justify-content-center pt-6'>
            <CompanyProfile className='mb-4' />
            <h2 className='section-heading m-0 mt-4 mb-2'>Verify Company Profile</h2>
            <p className='fs-4 mb-6 text-center' style={{ color: '#595959' }}>
              Please select how you would like <br /> to verify your company profile
            </p>
          </div>

          <div className='d-block mx-5 my-5'>
            <div className='d-flex align-items-center min-h-145px'>
              <div className='fv-row fv-plugins-icon-container w-100'>
                <div className='row'>
                  <div className='col-lg-12 loan-application '>
                    <label
                      className={`btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center mb-5 verify-profile ${
                        companyVerificationMethod === 1 ? 'verify-profile-click' : ''
                      }`}
                      htmlFor='kt_create_account_form_account_type_personal'
                      onClick={() => selectCompanyVerificationMethod(1)}
                    >
                      {/* <KTSVG
                        path='/media/icons/duotune/communication/com005.svg'
                        className='svg-icon-3x me-5'
                      /> */}

                      {/* <span className='text-dark fw-bolder d-block fs-4 mb-2'>MyInfo Business with Singpass</span> */}
                      <BankIcon
                        color={companyVerificationMethod === 1 ? 'var(--primary-color)' : '#D1D1D1'}
                      />
                      <span className='d-block fw-bold text-start ms-4'>
                        <span className='text-primary fw-bold d-block fs-3 mb-0 font-secondary'>
                          MyInfo Business with SingPass
                        </span>
                        <span className='fw-light text-color-10  fs-6'>
                          Takes about 1-2 minutes
                        </span>
                      </span>
                    </label>
                  </div>

                  <div className='col-lg-12 loan-application '>
                    <label
                      className={`btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center verify-profile-manual ${
                        companyVerificationMethod === 2 ? 'selected_manual' : ''
                      }`}
                      htmlFor='kt_create_account_form_account_type_corporate'
                      onClick={() => selectCompanyVerificationMethod(2)}
                    >
                      <TileIcon
                        secondaryColor={companyVerificationMethod === 2 ? '#038494' : '#E1E1E1'}
                        color={companyVerificationMethod === 2 ? 'var(--primary-color)' : '#D1D1D1'}
                      />

                      <span className='d-block text-start ms-4'>
                        <span className='text-primary fw-bold d-block fs-3 mb-0 text-primary font-secondary'>
                          Fill out details Manually
                        </span>
                        <span className='fw-light text-gray-700 fs-6'>
                          Takes about 5-10 minutes
                        </span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex flex-column gap-5 flex-center mx-5 my-10'>
            <button
              className='button button-primary  w-100'
              onClick={() => submitProfileVerification()}
            >
              Verify
            </button>
            <button className='button button-outline-back w-100' onClick={() => handleClose()}>
              Back
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CompanyVerification
